import { InputGroup } from 'react-bootstrap'
import IconActionWrapper from './button/IconActionWrapper'

const InputPrepend = (props) => {
  let { uischema } = props
  let { prependIcon = null, prependIconTooltip = null } = uischema
  if (prependIcon) {
    return (
      <InputGroup.Prepend>
        <IconActionWrapper
          {...props}
          iconName={prependIcon}
          iconTooltip={prependIconTooltip}
          border={{ borderRadius: '6px 0px 0px 6px' }}
        />
      </InputGroup.Prepend>
    )
  }
  return ''
}

export default InputPrepend
